export default "__VITE_PUBLIC_ASSET__7b1e8cb0__"